import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=703529a0&"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports